import { render, staticRenderFns } from "./switchRecord.vue?vue&type=template&id=2de3ac53&scoped=true&"
import script from "./switchRecord.vue?vue&type=script&lang=js&"
export * from "./switchRecord.vue?vue&type=script&lang=js&"
import style0 from "./switchRecord.vue?vue&type=style&index=0&id=2de3ac53&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de3ac53",
  null
  
)

export default component.exports